var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17319_53797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 1.66406C5.39999 1.66406 1.66666 5.3974 1.66666 9.9974C1.66666 14.5974 5.39999 18.3307 9.99999 18.3307C14.6 18.3307 18.3333 14.5974 18.3333 9.9974C18.3333 5.3974 14.6 1.66406 9.99999 1.66406ZM10.8333 15.8307H9.16666V14.1641H10.8333V15.8307ZM12.5583 9.3724L11.8083 10.1391C11.2083 10.7474 10.8333 11.2474 10.8333 12.4974H9.16666V12.0807C9.16666 11.1641 9.54166 10.3307 10.1417 9.7224L11.175 8.6724C11.4833 8.3724 11.6667 7.95573 11.6667 7.4974C11.6667 6.58073 10.9167 5.83073 9.99999 5.83073C9.08332 5.83073 8.33332 6.58073 8.33332 7.4974H6.66666C6.66666 5.65573 8.15832 4.16406 9.99999 4.16406C11.8417 4.16406 13.3333 5.65573 13.3333 7.4974C13.3333 8.23073 13.0333 8.8974 12.5583 9.3724Z",
    fill: "#53A551"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17319_53797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.3243d7b64d2edc2dae0621781f4b9337.svg";
export { ForwardRef as ReactComponent };